import { axios } from '@/utils/request'
const api = "/Home"
export default {
  upload: (parameter) => {
    return axios({
      url: `${api}/upload`,
      method: 'post',
      data: parameter
    })
  },
  upload_video: (parameter) => {
    return axios({
      url: `${api}/upload_video`,
      method: 'post',
      data: parameter
    })
  },
}